
export default {
  name: 'PagesAboutExtentionsBusinessPurposes',
  data() {
    return {
      scopes: [
        {
          id: 1,
          img: '/img/scope_1.png',
          title: 'Развитые сервисы подписки',
          description:
            'Можно отслеживать изменения в компании-поставщике или поставить на контроль целую тему, чтобы не пропустить важное обновление.',
        },
        {
          id: 2,
          img: '/img/scope_2.png',
          title: 'Авторские блоги',
          description:
            'Любой пользователь может стать автором на Мегасреде и развивать свой персональный бренд в профессиональном сообществе. Просто делитесь материалами и собирайте аудиторию вокруг себя.',
        },
        {
          id: 3,
          img: '/img/scope_3.png',
          title: 'Обзоры на сервисы',
          description:
            'Сделаны обзоры на все популярные сервисы. Прежде чем приобретать, ознакомьтесь. Возможно, найдете выгодную альтернативу',
        },
        {
          id: 4,
          img: '/img/scope_4.png',
          title: 'Мегалекция',
          description:
            'Сервис коротких профессиональных обучающих видеоматериалов.',
        },
      ],
    }
  },
}
